import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'

function LegalContnet({page, data}) {
  return (
    <> 
    <section className="legal-contnet">
      <Container>
        <Row>
          <Col sm="12">    
            <div className="legal-contnet-box">        
              <h2>{page} </h2>
              <div
                  dangerouslySetInnerHTML={{ __html: data }}
                ></div>
            </div>
          </Col>         
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default LegalContnet